import { IDateTimeSelectStepState } from 'src/entities/dateTime';
import { IValidationRule, required } from './validations';

const getDateTimeSelectFields = () => {
    const dateField: keyof IDateTimeSelectStepState = 'selectedDate';
    const timeField: keyof IDateTimeSelectStepState = 'selectedTime';

    return {
        Date: dateField,
        Time: timeField        
    }
}

export const dateTimeSelectFields = getDateTimeSelectFields();

export const dateTimeSelectRules: IValidationRule[] = [
    required(dateTimeSelectFields.Date),
    required(dateTimeSelectFields.Time)
];